module.exports = __webpack_public_path__ + "img/fixing-bugs-dark.7bc4998c.svg";